/**
 * Freemium Query Hooks
 *
 * TanStack Query hooks for the public/freemium layer.
 * All endpoints are unauthenticated — no token required.
 */

import { useQuery } from '@tanstack/react-query';
import { publicClient } from '../client/public.client';
import { queryKeys } from '../query-keys';

/**
 * Fetch paginated public videos, optionally filtered by channel.
 * Used on /{handler} page for guest users.
 */
export function usePublicVideos(
  filters?: { creators?: number; page?: number; per_page?: number } | undefined
) {
  return useQuery({
    queryKey: queryKeys.freemium.videos(filters as Record<string, unknown>),
    queryFn: () => publicClient.getPublicVideos(filters!),
    staleTime: 1000 * 60 * 5,
    enabled: !!filters,
  });
}

/**
 * Fetch a single public video for playback with 5 recommendations.
 * Returns 404 if not public — caller should handle redirect to /creators.
 */
export function usePublicVideoPlay(uuid: string | undefined) {
  return useQuery({
    queryKey: queryKeys.freemium.videoPlay(uuid || ''),
    queryFn: () => publicClient.getPublicVideoPlay(uuid!),
    staleTime: 1000 * 60 * 5,
    enabled: !!uuid,
  });
}
